import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@library-shared/base/base.component';

@Component({
  selector: 'app-sample-tickets-nassau',
  templateUrl: './sample-tickets-nassau.component.html',
  styleUrls: ['./sample-tickets-nassau.component.scss'],
  standalone: false,
})
export class SampleTicketsNassauComponent extends BaseComponent implements OnInit {
  constructor() {
    super();
  }

  ngOnInit(): void {}
}
